(function () {

  var LP_LANG = ((document.documentElement.lang || (window.Shopify && window.Shopify.locale) || 'en') + '').slice(0, 2).toLowerCase();
  var LP_I18N = {
    ja: {
      chooseTheme: 'テーマを選ぶ', productSetup: '商品設定', selectProductEditorThe: 'テーマエディタで商品を選択してください',
      quantity: '数量', qty: '数量', qtyLabel: '数量',
      panelThemes: 'パネルテーマ', animeThemes: 'アニメテーマ',
      filterAcrylic: 'アクリルデザインで絞り込む', filterSeries: 'シリーズで絞り込む', readyToBrowse: '閲覧の準備ができました',
      quickAdd: 'クイック追加', addToCartMobile: 'カートに追加', selectScene: 'シーンを選ぶ',
      acrylicPanelDesc: 'アクリル交換パネルデザイン', unavailable: 'ご利用いただけません', selectProduct: '商品を選択',
      selectAcrylicEditor: 'テーマエディタでアクリル商品を選択', selectProductEditor: 'テーマエディタで商品を選択',
      soldOut: '在庫切れ', inStock: '在庫あり', addAcrylic: 'アクリルパネルを追加', addToCart: 'カートに追加',
      frameColor: 'フレームの色', remove: '削除',
      cartOpenToLoad: 'カートを開いて最新のアイテムを読み込みます。', cartPickScene: 'ギャラリーからシーンを選んで、あなたのウォールを作り始めましょう。',
      loading: '読み込み中…', viewDetails: '詳細を見る',
      trustHandmade: '全世界送料無料', trustShips: '満足保証', trustSecure: '安全なお支払い', reviewsWord: 'レビュー', buyNow: '今すぐ購入',
      adding: '追加中…', added: '追加しました ✓', allAnime: 'すべてのアニメテーマ', allPanel: 'すべてのパネルテーマ',
      showingAnime: function (n, x) { return x + 'のアニメシーンを' + n + '件表示'; },
      showingPanel: function (n, x) { return x + 'のアクリルパネルデザインを' + n + '件表示'; },
      showingPieces: function (n, c) { return c + 'の作品を' + n + '件表示'; },
      fmtTheme: function (t) { return t + 'テーマ'; }, fmtLandscape: function (t) { return t + '（風景）'; }
    },
    ko: {
      chooseTheme: '테마 선택', productSetup: '상품 설정', selectProductEditorThe: '테마 편집기에서 상품을 선택하세요',
      quantity: '수량', qty: '수량', qtyLabel: '수량',
      panelThemes: '패널 테마', animeThemes: '애니메이션 테마',
      filterAcrylic: '아크릴 디자인으로 필터', filterSeries: '시리즈로 필터', readyToBrowse: '둘러볼 준비가 되었습니다',
      quickAdd: '빠른 담기', addToCartMobile: '장바구니에 담기', selectScene: '장면 선택',
      acrylicPanelDesc: '아크릴 교체 패널 디자인', unavailable: '구매 불가', selectProduct: '상품 선택',
      selectAcrylicEditor: '테마 편집기에서 아크릴 상품 선택', selectProductEditor: '테마 편집기에서 상품 선택',
      soldOut: '품절', inStock: '재고 있음', addAcrylic: '아크릴 패널 담기', addToCart: '장바구니에 담기',
      frameColor: '프레임 색상', remove: '삭제',
      cartOpenToLoad: '장바구니를 열어 최신 항목을 불러옵니다.', cartPickScene: '갤러리에서 장면을 선택해 나만의 월을 만들어 보세요.',
      loading: '불러오는 중…', viewDetails: '자세히 보기',
      trustHandmade: '전 세계 무료 배송', trustShips: '만족 보장', trustSecure: '안전한 결제', reviewsWord: '리뷰', buyNow: '지금 구매',
      adding: '담는 중…', added: '담았습니다 ✓', allAnime: '모든 애니메이션 테마', allPanel: '모든 패널 테마',
      showingAnime: function (n, x) { return x + '의 애니메이션 장면 ' + n + '개 표시'; },
      showingPanel: function (n, x) { return x + '의 아크릴 패널 디자인 ' + n + '개 표시'; },
      showingPieces: function (n, c) { return c + ' 작품 ' + n + '개 표시'; },
      fmtTheme: function (t) { return t + ' 테마'; }, fmtLandscape: function (t) { return t + ' 풍경'; }
    },
    de: {
      chooseTheme: 'Thema wählen', productSetup: 'Produkt-Setup', selectProductEditorThe: 'Wähle ein Produkt im Theme-Editor',
      quantity: 'Menge', qty: 'Menge', qtyLabel: 'Menge',
      panelThemes: 'Panel-Themen', animeThemes: 'Anime-Themen',
      filterAcrylic: 'Acryl-Designs filtern', filterSeries: 'Nach Serie filtern', readyToBrowse: 'Bereit zum Stöbern',
      quickAdd: 'Schnell hinzufügen', addToCartMobile: 'In den Warenkorb', selectScene: 'Szene wählen',
      acrylicPanelDesc: 'Acryl-Wechselpanel-Design', unavailable: 'Nicht verfügbar', selectProduct: 'Produkt auswählen',
      selectAcrylicEditor: 'Acryl-Produkt im Theme-Editor auswählen', selectProductEditor: 'Produkt im Theme-Editor auswählen',
      soldOut: 'Ausverkauft', inStock: 'Auf Lager', addAcrylic: 'Acrylpanel hinzufügen', addToCart: 'In den Warenkorb',
      frameColor: 'Rahmenfarbe', remove: 'Entfernen',
      cartOpenToLoad: 'Öffne den Warenkorb, um deine aktuellen Artikel zu laden.', cartPickScene: 'Wähle eine Szene aus der Galerie und beginne, deine Wand zu gestalten.',
      loading: 'Wird geladen …', viewDetails: 'Alle Details ansehen',
      trustHandmade: 'Weltweit kostenloser Versand', trustShips: 'Zufriedenheitsgarantie', trustSecure: 'Sicherer Checkout', reviewsWord: 'Bewertungen', buyNow: 'Jetzt kaufen',
      adding: 'Wird hinzugefügt …', added: 'Hinzugefügt ✓', allAnime: 'allen Anime-Themen', allPanel: 'allen Panel-Themen',
      showingAnime: function (n, x) { return 'Zeige ' + n + ' Anime-Szene' + (n === 1 ? '' : 'n') + ' in ' + x; },
      showingPanel: function (n, x) { return 'Zeige ' + n + ' Acrylpanel-Design' + (n === 1 ? '' : 's') + ' in ' + x; },
      showingPieces: function (n, c) { return 'Zeige ' + n + ' Stück' + (n === 1 ? '' : 'e') + ' aus ' + c; },
      fmtTheme: function (t) { return t + '-Thema'; }, fmtLandscape: function (t) { return t + ' Landschaft'; }
    }
  };
  var LP_T = LP_I18N[LP_LANG] || {};
  function lpt(k, fb) { return (LP_T[k] != null) ? LP_T[k] : fb; }

  var LP_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var LP_CATMAP = ({
    ja: {'Anime Light Painting':'アニメライトペインティング','Faith & Light Painting':'信仰&ライトペインティング','Landscape Series':'ランドスケープシリーズ','Pet Art':'ペットアート','Acrylic Art Panel':'アクリルアートパネル'},
    ko: {'Anime Light Painting':'애니메이션 라이트 페인팅','Faith & Light Painting':'신앙 & 라이트 페인팅','Landscape Series':'풍경 시리즈','Pet Art':'반려동물 아트','Acrylic Art Panel':'아크릴 아트 패널'},
    de: {'Anime Light Painting':'Anime-Leuchtbild','Faith & Light Painting':'Glaube & Leuchtbild','Landscape Series':'Landschaftsserie','Pet Art':'Haustier-Kunst','Acrylic Art Panel':'Acryl-Kunstpanel'}
  })[LP_LANG] || {};
  var LP_THEMEMAP = ({
    ja: {'All':'すべて','Arcane':'アーケイン','Jujutsu Kaisen':'呪術廻戦','Cyberpunk':'サイバーパンク','Solo leveling':'俺だけレベルアップな件','Frieren':'葬送のフリーレン','Naruto':'ナルト','One Piece':'ワンピース','Attack On Titan':'進撃の巨人','Demon Slayer':'鬼滅の刃','Dragon Ball':'ドラゴンボール','Pokemon':'ポケモン','Your Name':'君の名は','Other Anime':'その他のアニメ','Gaming Art':'ゲーミングアート','Evangelion':'エヴァンゲリオン','Studio Ghibli':'スタジオジブリ','My Hero Academia':'僕のヒーローアカデミア','Oshi no Ko':'推しの子','Landscape Series':'ランドスケープ','Faith':'信仰','Pet Art':'ペットアート'},
    ko: {'All':'모두','Arcane':'아케인','Jujutsu Kaisen':'주술회전','Cyberpunk':'사이버펑크','Solo leveling':'나 혼자만 레벨업','Frieren':'장송의 프리렌','Naruto':'나루토','One Piece':'원피스','Attack On Titan':'진격의 거인','Demon Slayer':'귀멸의 칼날','Dragon Ball':'드래곤볼','Pokemon':'포켓몬','Your Name':'너의 이름은','Other Anime':'기타 애니메이션','Gaming Art':'게이밍 아트','Evangelion':'에반게리온','Studio Ghibli':'스튜디오 지브리','My Hero Academia':'나의 히어로 아카데미아','Oshi no Ko':'최애의 아이','Landscape Series':'풍경','Faith':'신앙','Pet Art':'반려동물 아트'},
    de: {'All':'Alle','Arcane':'Arcane','Jujutsu Kaisen':'Jujutsu Kaisen','Cyberpunk':'Cyberpunk','Solo leveling':'Solo Leveling','Frieren':'Frieren','Naruto':'Naruto','One Piece':'One Piece','Attack On Titan':'Attack on Titan','Demon Slayer':'Demon Slayer','Dragon Ball':'Dragon Ball','Pokemon':'Pokémon','Your Name':'Your Name','Other Anime':'Weitere Anime','Gaming Art':'Gaming-Art','Evangelion':'Evangelion','Studio Ghibli':'Studio Ghibli','My Hero Academia':'My Hero Academia','Oshi no Ko':'Oshi no Ko','Landscape Series':'Landschaft','Faith':'Glaube','Pet Art':'Haustier-Kunst'}
  })[LP_LANG] || {};
  function lpCat(c) { return LP_CATMAP[c] || c; }
  function lpTheme(t) { return LP_THEMEMAP[t] || t; }
  var LP_NAMEMAP = ({"ja": {"Mt. Fuji Little Shop – Cozy Japanese Scene": "富士山のちいさなお店 – 和みの日本の風景", "Nightscape – Neon Future in Light and Shadow": "ナイトスケープ ― 光と影のネオンの未来", "Lights of a Thousand Homes – Dreamy Starry Sky": "千の家の灯り ― 夢みる星空", "Sunny Day Storefront – Manga Street Scene": "晴れた日の店先 ― マンガの街角", "Van Gogh's Starry Night LED Light Painting": "ゴッホ「星月夜」LEDライトペインティング", "Light Painting LED Frame Lamp – Frescoed Lights": "ライトペインティング LEDフレームランプ ― フレスコの灯り", "City Cat at Night – Cyber City": "夜の街猫 ― サイバーシティ", "Golden Sunlight on Snow Mountain": "雪山に降りそそぐ黄金の陽光", "Cross of Revelation – Dreamy Blue Beam": "黙示録の十字架 ― 夢幻の青い光", "I Am With You Always – Matthew 28:20": "私はいつもあなたと共に ― マタイ 28:20", "I Am With You Always – LED Light Painting": "私はいつもあなたと共に ― LEDライトペインティング", "Van Gogh Impressionist Light Painting": "ゴッホ 印象派ライトペインティング", "Sunset Cats LED Anime Light Painting": "夕焼けの猫たち LEDアニメライトペインティング", "Cute Dalmatian Puppy Dog LED Light Painting": "かわいいダルメシアンの子犬 LEDライトペインティング", "Puppy Dog Splashing LED Light Painting": "水遊びする子犬 LEDライトペインティング", "Playful Kittens 4D LED Light Painting": "遊ぶ子猫たち 4D LEDライトペインティング", "Cats' Tender Gaze LED Light Painting": "猫たちのやさしいまなざし LEDライトペインティング", "Joyful Dog LED Light Painting": "楽しげな犬 LEDライトペインティング", "Yawning Kitty in Sunlight LED Light Painting": "陽だまりであくびする子猫 LEDライトペインティング", "The Cat's Rejection LED Light Painting": "猫のおことわり LEDライトペインティング", "Joyful Water Kitten Light Painting": "水遊びする楽しい子猫 ライトペインティング", "Stargazing Cat Light Painting": "星を見上げる猫 ライトペインティング"}, "ko": {"Mt. Fuji Little Shop – Cozy Japanese Scene": "후지산 작은 가게 – 포근한 일본 거리", "Nightscape – Neon Future in Light and Shadow": "나이트스케이프 ― 빛과 그림자의 네온 미래", "Lights of a Thousand Homes – Dreamy Starry Sky": "천 개의 집의 불빛 ― 꿈결 같은 별하늘", "Sunny Day Storefront – Manga Street Scene": "맑은 날의 가게 앞 ― 만화 거리 풍경", "Van Gogh's Starry Night LED Light Painting": "반 고흐 ‘별이 빛나는 밤’ LED 라이트 페인팅", "Light Painting LED Frame Lamp – Frescoed Lights": "라이트 페인팅 LED 프레임 램프 ― 프레스코 불빛", "City Cat at Night – Cyber City": "밤의 도시 고양이 ― 사이버 시티", "Golden Sunlight on Snow Mountain": "설산에 비치는 황금빛 햇살", "Cross of Revelation – Dreamy Blue Beam": "계시록의 십자가 ― 몽환의 푸른 빛", "I Am With You Always – Matthew 28:20": "내가 항상 너희와 함께 있으리라 ― 마태복음 28:20", "I Am With You Always – LED Light Painting": "내가 항상 너희와 함께 있으리라 ― LED 라이트 페인팅", "Van Gogh Impressionist Light Painting": "반 고흐 인상주의 라이트 페인팅", "Sunset Cats LED Anime Light Painting": "노을 속 고양이들 LED 애니메이션 라이트 페인팅", "Cute Dalmatian Puppy Dog LED Light Painting": "귀여운 달마시안 강아지 LED 라이트 페인팅", "Puppy Dog Splashing LED Light Painting": "물장구치는 강아지 LED 라이트 페인팅", "Playful Kittens 4D LED Light Painting": "장난치는 새끼 고양이 4D LED 라이트 페인팅", "Cats' Tender Gaze LED Light Painting": "고양이들의 다정한 눈빛 LED 라이트 페인팅", "Joyful Dog LED Light Painting": "즐거운 강아지 LED 라이트 페인팅", "Yawning Kitty in Sunlight LED Light Painting": "햇살 속 하품하는 고양이 LED 라이트 페인팅", "The Cat's Rejection LED Light Painting": "고양이의 거절 LED 라이트 페인팅", "Joyful Water Kitten Light Painting": "물놀이하는 즐거운 새끼 고양이 라이트 페인팅", "Stargazing Cat Light Painting": "별을 바라보는 고양이 라이트 페인팅"}, "de": {"Mt. Fuji Little Shop – Cozy Japanese Scene": "Kleiner Laden am Fuji – Gemütliche japanische Szene", "Nightscape – Neon Future in Light and Shadow": "Nachtansicht – Neon-Zukunft aus Licht und Schatten", "Lights of a Thousand Homes – Dreamy Starry Sky": "Lichter tausender Häuser – Traumhafter Sternenhimmel", "Sunny Day Storefront – Manga Street Scene": "Sonniger Ladeneingang – Manga-Straßenszene", "Van Gogh's Starry Night LED Light Painting": "Van Goghs Sternennacht LED-Leuchtbild", "Light Painting LED Frame Lamp – Frescoed Lights": "LED-Leuchtbild-Rahmenlampe – Fresken-Lichter", "City Cat at Night – Cyber City": "Stadtkatze bei Nacht – Cyber City", "Golden Sunlight on Snow Mountain": "Goldenes Sonnenlicht auf dem Schneeberg", "Cross of Revelation – Dreamy Blue Beam": "Kreuz der Offenbarung – Traumhafter blauer Strahl", "I Am With You Always – Matthew 28:20": "Ich bin bei euch alle Tage – Matthäus 28:20", "I Am With You Always – LED Light Painting": "Ich bin bei euch alle Tage – LED-Leuchtbild", "Van Gogh Impressionist Light Painting": "Van Gogh Impressionismus-Leuchtbild", "Sunset Cats LED Anime Light Painting": "Sonnenuntergangs-Katzen LED-Anime-Leuchtbild", "Cute Dalmatian Puppy Dog LED Light Painting": "Niedlicher Dalmatiner-Welpe LED-Leuchtbild", "Puppy Dog Splashing LED Light Painting": "Planschender Welpe LED-Leuchtbild", "Playful Kittens 4D LED Light Painting": "Verspielte Kätzchen 4D-LED-Leuchtbild", "Cats' Tender Gaze LED Light Painting": "Sanfter Blick der Katzen LED-Leuchtbild", "Joyful Dog LED Light Painting": "Fröhlicher Hund LED-Leuchtbild", "Yawning Kitty in Sunlight LED Light Painting": "Gähnendes Kätzchen im Sonnenlicht LED-Leuchtbild", "The Cat's Rejection LED Light Painting": "Die Abweisung der Katze LED-Leuchtbild", "Joyful Water Kitten Light Painting": "Fröhliches Wasser-Kätzchen Leuchtbild", "Stargazing Cat Light Painting": "Sterneguckende Katze Leuchtbild"}})[LP_LANG] || {};
  function lpName(n) { return LP_NAMEMAP[n] || n; }
  const nonAnimeScenes = [
    { category: 'Landscape Series', code: 'Nightscape', name: 'Nightscape – Neon Future in Light and Shadow', theme: 'Landscape Series', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/city-nightscape-light-painting-art-frame-usb-pluglight-paintingbasesunbasesun-886191.jpg', product_handle: 'basesun-city-nightscape-light-painting-art-frame' },
    { category: 'Landscape Series', code: 'Lights of a Thousand Homes', name: 'Lights of a Thousand Homes – Dreamy Starry Sky', theme: 'Landscape Series', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/lights-of-a-thousand-homes-light-painting-art-in-a-dreamy-starry-skylight-paintingbasesunbasesun-406397.jpg', product_handle: 'lights-of-a-thousand-homes-light-painting-art-in-a-dreamy-starry-sky' },
    { category: 'Landscape Series', code: 'Sunny Day Storefront', name: 'Sunny Day Storefront – Manga Street Scene', theme: 'Landscape Series', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/sunny-day-storefront-manga-street-scene-led-light-painting-cozy-and-healing-decorlight-paintingbasesunbasesun-439930.jpg', product_handle: 'sunny-day-storefront-manga-street-scene-led-light-painting-cozy-and-healing-decor' },
    { category: 'Landscape Series', code: 'Van Gogh Starry Night', name: "Van Gogh's Starry Night LED Light Painting", theme: 'Landscape Series', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/starry-night-led-light-up-painting-frame-night-lightlight-paintingbasesunbasesun-370838.jpg', product_handle: 'van-gogh-s-starry-night-led-light-up-painting-frame-night-light' },
    { category: 'Landscape Series', code: 'Frescoed Lights', name: 'Light Painting LED Frame Lamp – Frescoed Lights', theme: 'Landscape Series', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/products/light-painting-led-light-frame-lamp-frescoed-lights-night-light-artlight-paintingbasesunbasesun-196874.jpg', product_handle: 'led-light-art-table-lamp-night-light' },
    { category: 'Landscape Series', code: 'City Cat at Night', name: 'City Cat at Night – Cyber City', theme: 'Landscape Series', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/MHYJ01-1.webp', product_handle: 'city-cat-at-night-led-light-box' },
    { category: 'Landscape Series', code: 'Snow Mountain', name: 'Golden Sunlight on Snow Mountain', theme: 'Landscape Series', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/RZJS01.jpg', product_handle: 'golden-sunlight-on-snow-mountain-led-light-painting' },
    { category: 'Landscape Series', code: 'Mt Fuji Shop', name: 'Mt. Fuji Little Shop – Cozy Japanese Scene', theme: 'Landscape Series', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/FSSXXD01-7_5a04c106-1435-4cda-a045-c3bfc691826e.jpg?v=1781877454', product_handle: 'mt-fuji-little-shop-led-light-box-japanese-healing-scene-art-cozy-street-corner-decor' },
    { category: 'Faith & Light Painting', code: 'Cross of Revelation', name: 'Cross of Revelation – Dreamy Blue Beam', theme: 'Faith', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/IMG_1281.jpg', product_handle: 'cross-of-revelation-dreamy-blue-beam-led-light-painting-gift-night-light' },
    { category: 'Faith & Light Painting', code: 'Matthew 28:20', name: 'I Am With You Always – Matthew 28:20', theme: 'Faith', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/MTFY02-1.jpg', product_handle: 'i-am-with-you-always-matthew-28-20-bible-verse-led-light-painting' },
    { category: 'Faith & Light Painting', code: 'I Am With You Always', name: 'I Am With You Always – LED Light Painting', theme: 'Faith', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/matthew-2820-anime-led-light-painting-photo-framelight-paintingbasesunbasesun-798642.jpg', product_handle: 'led-light-painting-i-am-with-you-always' },
    { category: 'Faith & Light Painting', code: 'Van Gogh Impressionist', name: 'Van Gogh Impressionist Light Painting', theme: 'Faith', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/impressionist-light-up-painting-frame-create-an-artistic-ambiance-night-lightlight-paintingbasesunbasesun-791748.jpg', product_handle: 'van-gogh-impressionist-light-up-painting-frame-create-an-artistic-ambiance-night-light' },
    { category: 'Pet Art', code: 'City Cat at Night', name: 'City Cat at Night – Cyber City', theme: 'Pet Art', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/MHYJ01-1.webp', product_handle: 'city-cat-at-night-led-light-box' },
    { category: 'Pet Art', code: 'Sunset Cats', name: 'Sunset Cats LED Anime Light Painting', theme: 'Pet Art', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/szm01.jpg', product_handle: 'sunset-cats-led-anime-light-painting-cozy-cat-lover-wall-decor' },
    { category: 'Pet Art', code: 'Cute Dalmatian Puppy', name: 'Cute Dalmatian Puppy Dog LED Light Painting', theme: 'Pet Art', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/cute-dalmatian-puppy-dog-led-light-up-painting-frame-glowing-frame-night-lightlight-paintingbasesunbasesun-743235.jpg', product_handle: 'cute-dalmatian-puppy-dog-led-light-up-painting-frame-glowing-frame-night-light' },
    { category: 'Pet Art', code: 'Puppy Dog Splashing', name: 'Puppy Dog Splashing LED Light Painting', theme: 'Pet Art', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/puppy-dog-splashing-led-light-up-painting-frame-glowing-frame-night-lightlight-paintingbasesunbasesun-287472.jpg', product_handle: 'puppy-dog-splashing-led-light-up-painting-frame-glowing-frame-night-light' },
    { category: 'Pet Art', code: 'Playful Kittens', name: 'Playful Kittens 4D LED Light Painting', theme: 'Pet Art', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/playful-kittens-4d-led-light-up-painting-glowing-framelight-paintingbasesunbasesun-147471.jpg', product_handle: 'stargazing-cat-light-painting-artwork-table-lamp-night-light-复制' },
    { category: 'Pet Art', code: "Cats' Tender Gaze", name: "Cats' Tender Gaze LED Light Painting", theme: 'Pet Art', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/cats-tender-gaze-led-light-up-painting-frame-night-light-lamplight-paintingbasesunbasesun-681626.jpg', product_handle: 'cats-tender-gaze-led-light-up-painting-frame-night-light-lamp' },
    { category: 'Pet Art', code: 'Joyful Dog', name: 'Joyful Dog LED Light Painting', theme: 'Pet Art', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/joyful-dog-led-light-up-painting-frame-artwork-table-lamp-night-lightlight-paintingbasesunbasesun-885178.jpg', product_handle: 'joyful-dog-led-light-up-painting-frame-artwork-table-lamp-night-light' },
    { category: 'Pet Art', code: 'Yawning Kitty', name: 'Yawning Kitty in Sunlight LED Light Painting', theme: 'Pet Art', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/cat-led-light-painting-lamp-artwork-a-fusion-of-light-and-art-yawning-kitty-in-sunlightlight-paintingbasesunbasesun-670603.jpg', product_handle: 'cat-led-light-painting-lamp-artwork-a-fusion-of-light-and-art-yawning-kitty-in-sunlight' },
    { category: 'Pet Art', code: "The Cat's Rejection", name: "The Cat's Rejection LED Light Painting", theme: 'Pet Art', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/the-cats-rejection-led-light-painting-lamp-artwork-night-lightlight-paintingbasesunbasesun-396490.jpg', product_handle: 'the-cats-rejection-led-light-painting-lamp-artwork-night-light' },
    { category: 'Pet Art', code: 'Water Kitten', name: 'Joyful Water Kitten Light Painting', theme: 'Pet Art', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/joyful-water-kitten-light-painting-artwork-table-lamp-night-lightlight-paintingbasesunbasesun-483182.jpg', product_handle: 'joyful-water-kitten-cat-light-painting-artwork-night-light' },
    { category: 'Pet Art', code: 'Stargazing Cat', name: 'Stargazing Cat Light Painting', theme: 'Pet Art', image: 'https://cdn.shopify.com/s/files/1/0576/4510/5175/files/stargazing-cat-light-painting-artwork-table-lamp-night-lightlight-paintingbasesunbasesun-378115.jpg', product_handle: 'stargazing-cat-light-painting-artwork-table-lamp-night-light' }
  ];

  // 非动漫(Landscape/Faith/Pet)优先用 section 按集合输出的实时数据(上架即显示、顺序=集合后台排序)，取不到再用上面的兜底数组
  const NONANIME = (typeof window !== 'undefined' && Array.isArray(window.LP_NONANIME) && window.LP_NONANIME.length) ? window.LP_NONANIME : nonAnimeScenes;

  const fallbackAnimeScenes = [
    { category: 'Anime Light Painting', code: 'ARC-01', name: 'Arcane ARC-01', theme: 'Arcane', image: 'https://images.unsplash.com/photo-1518895949257-7621c3c786d7?auto=format&fit=crop&w=900&q=80' },
    { category: 'Anime Light Painting', code: 'JJK-11', name: 'Jujutsu Kaisen JJK-11', theme: 'Jujutsu Kaisen', image: 'https://images.unsplash.com/photo-1515405295579-ba7b45403062?auto=format&fit=crop&w=900&q=80' },
    { category: 'Anime Light Painting', code: 'CP-07', name: 'Cyberpunk CP-07', theme: 'Cyberpunk', image: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=900&q=80' },
    { category: 'Anime Light Painting', code: 'NRT-03', name: 'Naruto NRT-03', theme: 'Naruto', image: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=900&q=80' },
    { category: 'Anime Light Painting', code: 'OP-19', name: 'One Piece OP-19', theme: 'One Piece', image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=900&q=80' },
    { category: 'Anime Light Painting', code: 'FR-08', name: 'Frieren FR-08', theme: 'Frieren', image: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=900&q=80' }
  ];

  const categories = ['Anime Light Painting', 'Faith & Light Painting', 'Landscape Series', 'Pet Art', 'Acrylic Art Panel'];
  const DEFAULT_PREFERENCES = {
    size: ['Large'],
    color: ['Wood', 'Natural', 'Oak', 'Walnut'],
    remote: ['With Remote']
  };

  function normalizeProductData(parsed) {
    return {
      hasProduct: !!parsed.hasProduct,
      id: parsed.id,
      title: parsed.title,
      available: !!parsed.available,
      priceMin: parsed.priceMin || 0,
      options: Array.isArray(parsed.options) ? parsed.options : [],
      variants: Array.isArray(parsed.variants) ? parsed.variants : [],
      media: Array.isArray(parsed.media) ? parsed.media : []
    };
  }

  function parseProductData(root) {
    const script = root.querySelector('[data-role="product-data"]');
    if (!script) {
      return {
        led: normalizeProductData({}),
        acrylic: normalizeProductData({})
      };
    }
    try {
      const parsed = JSON.parse(script.textContent || '{}');
      return {
        led: normalizeProductData(parsed.led || {}),
        acrylic: normalizeProductData(parsed.acrylic || {})
      };
    } catch (error) {
      console.error('Unable to parse product data:', error);
      return {
        led: normalizeProductData({}),
        acrylic: normalizeProductData({})
      };
    }
  }

  function buildAnimeScenesFromJson(data) {
    return Object.entries(data || {}).flatMap(([theme, entries]) => {
      if (!Array.isArray(entries)) return [];
      return entries.map((entry) => ({
        category: 'Anime Light Painting',
        code: entry.code || theme,
        name: entry.name || (theme + ' ' + (entry.code || 'Scene')),
        theme,
        image: entry.previewUrl || entry.url || '',
        sourceUrl: entry.url || entry.previewUrl || '',
        product_handle: entry.product_handle || null
      })).filter((scene) => scene.image);
    });
  }

  function buildAcrylicScenesFromJson(data) {
    return Object.entries(data || {}).flatMap(([theme, entries]) => {
      if (!Array.isArray(entries)) return [];
      return entries.map((entry) => ({
        category: 'Acrylic Art Panel',
        code: entry.code || theme,
        name: entry.name || (theme + ' ' + (entry.code || 'Panel')),
        theme,
        image: entry.previewUrl || entry.url || '',
        sourceUrl: entry.url || entry.previewUrl || ''
      })).filter((scene) => scene.image);
    });
  }

  async function loadAnimeScenes(url) {
    if (!url) return fallbackAnimeScenes;
    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Failed to load scene data');
      const data = await response.json();
      const normalized = buildAnimeScenesFromJson(data);
      return normalized.length ? normalized : fallbackAnimeScenes;
    } catch (error) {
      console.error('Unable to load anime scene data:', error);
      return fallbackAnimeScenes;
    }
  }

  async function loadAcrylicScenes(url) {
    if (!url) return [];
    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Failed to load acrylic scene data');
      const data = await response.json();
      return buildAcrylicScenesFromJson(data);
    } catch (error) {
      console.error('Unable to load acrylic scene data:', error);
      return [];
    }
  }

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format((cents || 0) / 100);
  }

  function slugifyCategory(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getOptionPreferenceKey(optionName) {
    const name = String(optionName || '').toLowerCase();
    if (name.includes('size')) return 'size';
    if (name.includes('frame') || name.includes('color') || name.includes('colour')) return 'color';
    if (name.includes('remote')) return 'remote';
    return null;
  }

  function getDefaultOptionValue(option) {
    const values = Array.isArray(option.values) ? option.values : [];
    const key = getOptionPreferenceKey(option.name);
    const preferredValues = key ? DEFAULT_PREFERENCES[key] : [];
    const preferred = preferredValues.find((value) => values.includes(value));
    return preferred || values[0] || '';
  }

  function findVariantByOptions(productData, optionValues) {
    if (!productData || !Array.isArray(productData.variants)) return null;
    return productData.variants.find((variant) => {
      if (!Array.isArray(variant.options)) return false;
      return productData.options.every((option, index) => variant.options[index] === optionValues[option.name]);
    }) || null;
  }

  function buildInitialOptionValues(productData) {
    const optionValues = {};
    (productData.options || []).forEach((option) => {
      optionValues[option.name] = getDefaultOptionValue(option);
    });
    const matchedVariant = findVariantByOptions(productData, optionValues);
    if (matchedVariant && Array.isArray(matchedVariant.options)) {
      productData.options.forEach((option, index) => {
        optionValues[option.name] = matchedVariant.options[index];
      });
    }
    return optionValues;
  }

  async function initSection(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    let scenes = NONANIME.slice();
    const productSources = parseProductData(root);
    const initialProductKey = 'led';
    const initialProductData = productSources[initialProductKey];
    let animeScenesCache = null;
    let animeScenesPromise = null;
    let acrylicScenesCache = null;
    let acrylicScenesPromise = null;
    let cartPromise = null;
    let quickAddModal = null;

    const defaultCategory = root.dataset.defaultCategory || 'Landscape Series';
    const defaultTheme = root.dataset.defaultTheme || 'All';
    const state = {
      category: defaultCategory,
      theme: 'All',
      query: '',
      selectedScene: NONANIME.find((scene) => scene.category === defaultCategory) || NONANIME[0],
      cart: { item_count: 0, items: [], total_price: 0 },
      cartLoaded: false,
      cartJustOpenedUntil: 0,
      productSources,
      activeProductKey: initialProductKey,
      productData: initialProductData,
      optionValues: buildInitialOptionValues(initialProductData),
      quantity: 1,
      selectedVariant: null,
      currency: root.dataset.currency || 'USD'
    };

    const elements = {
      categoryStrip: root.querySelector('[data-role="category-strip"]'),
      subthemeBlock: root.querySelector('[data-role="subtheme-block"]'),
      subthemeHint: root.querySelector('[data-role="subtheme-hint"]'),
      themeStrip: root.querySelector('[data-role="theme-strip"]'),
      mobileThemeNav: root.querySelector('[data-role="mobile-theme-nav"]'),
      mobileThemePrev: root.querySelector('[data-role="mobile-theme-prev"]'),
      mobileThemeCurrent: root.querySelector('[data-role="mobile-theme-current"]'),
      mobileThemeNext: root.querySelector('[data-role="mobile-theme-next"]'),
      themeModal: root.querySelector('[data-role="theme-modal"]'),
      themeModalBackdrop: root.querySelector('[data-role="theme-modal-backdrop"]'),
      themeModalClose: root.querySelector('[data-role="theme-modal-close"]'),
      themeModalList: root.querySelector('[data-role="theme-modal-list"]'),
      imagePreviewModal: root.querySelector('[data-role="image-preview-modal"]'),
      imagePreviewBackdrop: root.querySelector('[data-role="image-preview-backdrop"]'),
      imagePreviewClose: root.querySelector('[data-role="image-preview-close"]'),
      imagePreviewImg: root.querySelector('[data-role="image-preview-img"]'),
      imagePreviewSheet: root.querySelector('[data-role="image-preview-sheet"]'),
      sceneGrid: root.querySelector('[data-role="scene-grid"]'),
      resultSummary: root.querySelector('[data-role="result-summary"]'),
      clearSearchBtn: root.querySelector('[data-role="clear-search"]'),
      themeSearchInput: root.querySelector('[data-role="theme-search"]'),
      startingPrice: root.querySelector('[data-role="starting-price"]'),
      selectedImage: root.querySelector('[data-role="selected-image"]'),
      selectedName: root.querySelector('[data-role="selected-name"]'),
      selectedTheme: root.querySelector('[data-role="selected-theme"]'),
      selectedCode: root.querySelector('[data-role="selected-code"]'),
      selectedStatus: root.querySelector('[data-role="selected-status"]'),
      optionGrid: root.querySelector('[data-role="option-grid"]'),
      selectionSummaryText: root.querySelector('[data-role="selection-summary"]'),
      totalPrice: root.querySelector('[data-role="total-price"]'),
      addToCartBtn: root.querySelector('[data-role="add-to-cart"]'),
      mobileSelectedName: root.querySelector('[data-role="mobile-selected-name"]'),
      mobilePrice: root.querySelector('[data-role="mobile-price"]'),
      mobileDrawer: root.querySelector('[data-role="mobile-drawer"]'),
      mobileDrawerToggle: root.querySelector('[data-role="mobile-drawer-toggle"]'),
      mobileDrawerClose: root.querySelector('[data-role="mobile-drawer-close"]'),
      mobileDrawerContent: root.querySelector('[data-role="mobile-drawer-content"]'),
      floatingCart: root.querySelector('[data-role="floating-cart"]'),
      cartBackdrop: root.querySelector('[data-role="cart-backdrop"]'),
      cartToggleBtn: root.querySelector('[data-role="cart-toggle"]'),
      cartCloseBtn: root.querySelector('[data-role="cart-close"]'),
      cartCount: root.querySelector('[data-role="cart-count"]'),
      cartList: root.querySelector('[data-role="cart-list"]'),
      cartTotal: root.querySelector('[data-role="cart-total"]'),
      buyColumnEl: root.querySelector('[data-role="buy-column"]'),
      desktopCartList: root.querySelector('[data-role="desktop-cart-list"]'),
      desktopCartTotal: root.querySelector('[data-role="desktop-cart-total"]'),
      desktopCartCount: root.querySelector('[data-role="desktop-cart-count"]')
    };

    function isMobileViewport() {
      return window.innerWidth <= 820 || window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    }

    function isAcrylicCategory() {
      return state.category === 'Acrylic Art Panel';
    }

    function getActiveProductKeyForCategory(category) {
      return category === 'Acrylic Art Panel' ? 'acrylic' : 'led';
    }

    function setActiveProductForCategory(category, shouldResetOptions) {
      const nextKey = getActiveProductKeyForCategory(category);
      const nextProduct = state.productSources[nextKey] || normalizeProductData({});
      const productChanged = state.activeProductKey !== nextKey;
      state.activeProductKey = nextKey;
      state.productData = nextProduct;
      if (productChanged || shouldResetOptions) {
        state.optionValues = buildInitialOptionValues(nextProduct);
      }
      updateSelectedVariant();
    }

    function getMobileAnimeThemes() {
      return getThemes().filter((theme) => theme !== 'All');
    }

    function normalizeAnimeThemeForViewport() {
      if (state.category !== 'Anime Light Painting' && !isAcrylicCategory()) return;
      const mobileThemes = getMobileAnimeThemes();
      if (!mobileThemes.length) return;
      if (isMobileViewport() && state.theme === 'All') {
        state.theme = mobileThemes[0];
      }
      if (!isMobileViewport() && !getThemes().includes(state.theme)) {
        state.theme = 'All';
      }
    }

    function getSelectedOptionsText() {
      return (state.productData.options || []).map((option) => state.optionValues[option.name]).filter(Boolean).join(' / ');
    }

    function getCategoryScenes(category) {
      if (category === 'Acrylic Art Panel') {
        return scenes.filter((scene) => scene.category === 'Acrylic Art Panel');
      }
      return scenes.filter((scene) => scene.category === category);
    }

    function findFirstSceneByCategory(category) {
      return getCategoryScenes(category)[0] || null;
    }

    function applyLoadedScenes(category, loadedScenes) {
      scenes = scenes.filter((scene) => scene.category !== category).concat(loadedScenes || []);
    }

    async function ensureAnimeScenesLoaded() {
      if (animeScenesCache) return animeScenesCache;
      if (!animeScenesPromise) {
        animeScenesPromise = loadAnimeScenes(root.dataset.scenesUrl).then((loadedScenes) => {
          animeScenesCache = loadedScenes;
          applyLoadedScenes('Anime Light Painting', animeScenesCache);
          return animeScenesCache;
        }).finally(() => {
          animeScenesPromise = null;
        });
      }
      return animeScenesPromise;
    }

    async function ensureAcrylicScenesLoaded() {
      if (acrylicScenesCache) return acrylicScenesCache;
      if (!acrylicScenesPromise) {
        acrylicScenesPromise = loadAcrylicScenes(root.dataset.acrylicScenesUrl).then((loadedScenes) => {
          acrylicScenesCache = loadedScenes;
          applyLoadedScenes('Acrylic Art Panel', acrylicScenesCache);
          return acrylicScenesCache;
        }).finally(() => {
          acrylicScenesPromise = null;
        });
      }
      return acrylicScenesPromise;
    }

    async function ensureCategoryScenesLoaded(category) {
      if (category === 'Anime Light Painting') {
        await ensureAnimeScenesLoaded();
      }
      if (category === 'Acrylic Art Panel') {
        await ensureAcrylicScenesLoaded();
      }
    }

    async function changeCategory(category) {
      state.category = category;
      state.theme = 'All';
      state.query = '';
      await ensureCategoryScenesLoaded(category);
      state.selectedScene = findFirstSceneByCategory(category) || state.selectedScene;
      setActiveProductForCategory(category, true);
      state.quantity = 1;
      renderAll();
    }

    function resetCustomization() {
      state.optionValues = buildInitialOptionValues(state.productData);
      state.quantity = 1;
      updateSelectedVariant();
    }

    function getThemes() {
      const categoryScenes = getCategoryScenes(state.category);
      return ['All'].concat([...new Set(categoryScenes.map((scene) => scene.theme))]);
    }

    function getFilteredScenes() {
      return scenes.filter((scene) => {
        const categoryMatch = scene.category === state.category;
        const themedCategory = state.category === 'Anime Light Painting' || isAcrylicCategory();
        const themeMatch = !themedCategory || state.theme === 'All' || scene.theme === state.theme;
        const query = state.query.trim().toLowerCase();
        const queryMatch = !query ||
          scene.name.toLowerCase().includes(query) ||
          scene.code.toLowerCase().includes(query) ||
          scene.theme.toLowerCase().includes(query) ||
          scene.category.toLowerCase().includes(query);
        return categoryMatch && themeMatch && queryMatch;
      });
    }

    function updateSelectedVariant() {
      state.selectedVariant = findVariantByOptions(state.productData, state.optionValues);
    }

    function getCurrentTotalPrice() {
      return ((state.selectedVariant && state.selectedVariant.price) || 0) * state.quantity;
    }

    function toggleImagePreview(open, scene) {
      if (!elements.imagePreviewModal) return;
      const shouldOpen = typeof open === 'boolean' ? open : !elements.imagePreviewModal.classList.contains('open');
      if (shouldOpen && scene && elements.imagePreviewImg) {
        elements.imagePreviewImg.src = scene.image;
        elements.imagePreviewImg.alt = scene.name;
      }
      elements.imagePreviewModal.classList.toggle('open', shouldOpen);
      document.body.classList.toggle('lp-sheet-open', shouldOpen);
      elements.imagePreviewModal.setAttribute('aria-hidden', String(!shouldOpen));
    }

    function toggleThemeModal(open) {
      if (!elements.themeModal) return;
      const shouldOpen = typeof open === 'boolean' ? open : !elements.themeModal.classList.contains('open');
      elements.themeModal.classList.toggle('open', shouldOpen);
      document.body.classList.toggle('lp-sheet-open', shouldOpen);
      elements.themeModal.setAttribute('aria-hidden', String(!shouldOpen));
    }

    function renderThemeModalList() {
      if (!elements.themeModalList) return;
      elements.themeModalList.innerHTML = '';
      getMobileAnimeThemes().forEach((theme) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'theme-modal-item' + (theme === state.theme ? ' active' : '');
        button.textContent = lpTheme(theme);
        button.addEventListener('click', () => {
          state.theme = theme;
          const firstMatching = getFilteredScenes()[0];
          if (firstMatching) state.selectedScene = firstMatching;
          resetCustomization();
          toggleThemeModal(false);
          renderAll();
        });
        elements.themeModalList.appendChild(button);
      });
    }

    function renderMobileThemeNav() {
      if (!elements.mobileThemeNav) return;
      const shouldShow = (state.category === 'Anime Light Painting' || isAcrylicCategory()) && isMobileViewport();
      elements.mobileThemeNav.style.display = shouldShow ? 'flex' : 'none';
      if (!shouldShow) return;
      const mobileThemes = getMobileAnimeThemes();
      const currentTheme = state.theme === 'All' ? mobileThemes[0] : state.theme;
      const currentIndex = Math.max(0, mobileThemes.indexOf(currentTheme));
      if (elements.mobileThemeCurrent) elements.mobileThemeCurrent.textContent = currentTheme ? lpTheme(currentTheme) : lpt('chooseTheme','Choose theme');
      if (elements.mobileThemePrev) elements.mobileThemePrev.disabled = currentIndex <= 0;
      if (elements.mobileThemeNext) elements.mobileThemeNext.disabled = currentIndex < 0 || currentIndex >= mobileThemes.length - 1;
    }

    function stepMobileTheme(direction) {
      const mobileThemes = getMobileAnimeThemes();
      if (!mobileThemes.length) return;
      const currentTheme = state.theme === 'All' ? mobileThemes[0] : state.theme;
      const currentIndex = Math.max(0, mobileThemes.indexOf(currentTheme));
      const nextIndex = currentIndex + direction;
      if (nextIndex < 0 || nextIndex >= mobileThemes.length) return;
      state.theme = mobileThemes[nextIndex];
      const firstMatching = getFilteredScenes()[0];
      if (firstMatching) state.selectedScene = firstMatching;
      resetCustomization();
      renderAll();
    }

    function renderOptionGrid() {
      if (!state.productData.hasProduct || !state.productData.options.length) {
        elements.optionGrid.innerHTML = '<div class="selected-meta"><div><span>' + lpt('productSetup','Product setup') + '</span><strong>' + lpt('selectProductEditorThe','Select a product in the theme editor') + '</strong></div></div>';
        return;
      }

      const fieldsHtml = state.productData.options.map((option, index) => {
        const optionsHtml = (option.values || []).map((value) => {
          const selected = state.optionValues[option.name] === value ? ' selected' : '';
          return '<option value="' + value.replace(/"/g, '&quot;') + '"' + selected + '>' + value + '</option>';
        }).join('');
        return [
          '<label class="lp-field">',
          '  <span>' + option.name + '</span>',
          '  <select data-role="desktop-option" data-option-index="' + index + '" data-option-name="' + option.name.replace(/"/g, '&quot;') + '">',
          optionsHtml,
          '  </select>',
          '</label>'
        ].join('');
      }).join('');

      elements.optionGrid.innerHTML = fieldsHtml + [
        '<div class="lp-field">',
        '  <span>' + lpt('quantity','Quantity') + '</span>',
        '  <div class="qty-box">',
        '    <button data-role="qty-down" type="button" aria-label="Decrease quantity">-</button>',
        '    <input data-role="qty-input" type="number" min="1" value="' + state.quantity + '">',
        '    <button data-role="qty-up" type="button" aria-label="Increase quantity">+</button>',
        '  </div>',
        '</div>'
      ].join('');

      elements.optionGrid.querySelectorAll('[data-role="desktop-option"]').forEach((select) => {
        select.addEventListener('change', () => {
          state.optionValues[select.dataset.optionName] = select.value;
          updateSelectedVariant();
          renderSelection();
          renderMobileDrawer();
        });
      });

      const qtyInput = elements.optionGrid.querySelector('[data-role="qty-input"]');
      const qtyDown = elements.optionGrid.querySelector('[data-role="qty-down"]');
      const qtyUp = elements.optionGrid.querySelector('[data-role="qty-up"]');

      if (qtyInput) {
        qtyInput.addEventListener('input', () => {
          state.quantity = Math.max(1, Number(qtyInput.value || 1));
          qtyInput.value = String(state.quantity);
          renderSelection();
          renderMobileDrawer();
        });
      }
      if (qtyDown) {
        qtyDown.addEventListener('click', () => {
          state.quantity = Math.max(1, state.quantity - 1);
          renderSelection();
          renderOptionGrid();
          renderMobileDrawer();
        });
      }
      if (qtyUp) {
        qtyUp.addEventListener('click', () => {
          state.quantity += 1;
          renderSelection();
          renderOptionGrid();
          renderMobileDrawer();
        });
      }
    }

    function renderCategories() {
      elements.categoryStrip.innerHTML = '';
      categories.forEach((category) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'theme-chip category-chip' + (category === state.category ? ' active' : '');
        chip.textContent = lpCat(category);
        chip.addEventListener('click', async () => {
          await changeCategory(category);
        });
        elements.categoryStrip.appendChild(chip);
      });
    }

    function renderThemes() {
      elements.themeStrip.innerHTML = '';
      const showsThemes = state.category === 'Anime Light Painting' || isAcrylicCategory();
      elements.subthemeBlock.classList.toggle('hidden', !showsThemes);
      const themeLabel = isAcrylicCategory() ? lpt('panelThemes','Panel Themes') : lpt('animeThemes','Anime Themes');
      const themeHint = isAcrylicCategory() ? lpt('filterAcrylic','Filter acrylic designs') : lpt('filterSeries','Filter by series');
      const themeLabelNode = elements.subthemeBlock.querySelector('.toolbar-label');
      if (themeLabelNode) themeLabelNode.textContent = themeLabel;
      elements.subthemeHint.textContent = showsThemes ? themeHint : lpt('readyToBrowse','Ready to browse');
      if (!showsThemes) {
        renderMobileThemeNav();
        return;
      }

      normalizeAnimeThemeForViewport();

      getThemes().forEach((theme) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'theme-chip' + (theme === state.theme ? ' active' : '');
        chip.textContent = lpTheme(theme);
        chip.addEventListener('click', () => {
          state.theme = theme;
          const firstMatching = getFilteredScenes()[0];
          if (firstMatching) state.selectedScene = firstMatching;
          resetCustomization();
          renderAll();
        });
        elements.themeStrip.appendChild(chip);
      });

      renderThemeModalList();
      renderMobileThemeNav();
    }

    function renderScenes() {
      const filtered = getFilteredScenes();
      elements.sceneGrid.innerHTML = '';
      const hideAnimeSummaryOnMobile = state.category === 'Anime Light Painting' && isMobileViewport();
      elements.resultSummary.parentElement.dataset.mobileAnimeClean = hideAnimeSummaryOnMobile ? 'true' : 'false';
      if (elements.clearSearchBtn) elements.clearSearchBtn.style.display = 'none';
      const _lpAniX = state.theme === 'All' ? lpt('allAnime', 'all anime themes') : lpTheme(state.theme);
      const _lpPanX = state.theme === 'All' ? lpt('allPanel', 'all panel themes') : lpTheme(state.theme);
      elements.resultSummary.textContent = hideAnimeSummaryOnMobile
        ? ''
        : state.category === 'Anime Light Painting'
          ? (LP_T.showingAnime ? LP_T.showingAnime(filtered.length, _lpAniX) : 'Showing ' + filtered.length + ' anime scene' + (filtered.length === 1 ? '' : 's') + ' in ' + _lpAniX)
          : isAcrylicCategory()
            ? (LP_T.showingPanel ? LP_T.showingPanel(filtered.length, _lpPanX) : 'Showing ' + filtered.length + ' acrylic panel design' + (filtered.length === 1 ? '' : 's') + ' in ' + _lpPanX)
          : (LP_T.showingPieces ? LP_T.showingPieces(filtered.length, lpCat(state.category)) : 'Showing ' + filtered.length + ' piece' + (filtered.length === 1 ? '' : 's') + ' from ' + lpCat(state.category));

      filtered.forEach((scene) => {
        const hasProduct = !!scene.product_handle;
        const productUrl = hasProduct ? '/products/' + scene.product_handle : null;

        const card = document.createElement('article');
        card.className = 'scene-card' + (state.selectedScene && scene.code === state.selectedScene.code ? ' selected' : '');

        if (hasProduct) {
          const isCodeLabel = (state.category === 'Anime Light Painting' || isAcrylicCategory());
          const displayLabel = isCodeLabel ? scene.code : lpName(scene.name);
          card.innerHTML = [
            '<a class="scene-image-button" href="' + productUrl + '"><img loading="lazy" decoding="async" src="' + scene.image + '" alt="' + scene.name + '"></a>',
            '<div class="scene-card-body">',
            '  <div class="scene-card-top' + (isCodeLabel ? ' scene-card-top--code' : '') + '">',
            '    <a class="scene-card-title-link" href="' + productUrl + '"><strong>' + displayLabel + '</strong></a>',
            '  </div>',
            '  <div class="scene-card-footer">',
            '    <button class="secondary-btn" type="button">' + lpt('quickAdd','Quick Add') + '</button>',
            '  </div>',
            '</div>'
          ].join('');

          card.querySelector('.secondary-btn').addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            openQuickAdd(scene);
          });
        } else {
          card.innerHTML = [
            '<button class="scene-image-button" type="button" aria-label="View larger image for ' + scene.name.replace(/"/g, '&quot;') + '"><img loading="lazy" decoding="async" src="' + scene.image + '" alt="' + scene.name + '"></button>',
            '<div class="scene-card-body">',
            '  <div class="scene-card-top">',
            '    <strong>' + ((state.category === 'Anime Light Painting' || isAcrylicCategory()) ? scene.code : lpName(scene.name)) + '</strong>',
            '  </div>',
            '  <div class="scene-card-footer">',
            '    <button class="secondary-btn" type="button">' + (isMobileViewport() ? lpt('addToCartMobile','Add to Cart') : lpt('selectScene','Select scene')) + '</button>',
            '  </div>',
            '</div>'
          ].join('');

          card.addEventListener('click', () => {
            state.selectedScene = scene;
            resetCustomization();
            renderAll();
          });

          const imageButton = card.querySelector('.scene-image-button');
          if (imageButton) {
            imageButton.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              if (isMobileViewport()) {
                toggleImagePreview(true, scene);
                return;
              }
              state.selectedScene = scene;
              resetCustomization();
              renderAll();
            });
          }

          const selectButton = card.querySelector('.secondary-btn');
          selectButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            state.selectedScene = scene;
            resetCustomization();
            if (isMobileViewport()) {
              renderSelection();
              renderOptionGrid();
              renderMobileDrawer();
              toggleMobileDrawer(true);
              return;
            }
            renderAll();
          });
        }

        elements.sceneGrid.appendChild(card);
      });
    }

    function renderSelection() {
      const scene = state.selectedScene;
      if (!scene) return;
      const activeProduct = state.productData;
      elements.selectedImage.src = scene.image;
      elements.selectedImage.alt = scene.name;
      elements.selectedName.textContent = lpName(scene.name);
      elements.selectedTheme.textContent = isAcrylicCategory()
        ? lpt('acrylicPanelDesc', 'Acrylic replacement panel design')
        : scene.category === 'Landscape Series'
          ? (LP_T.fmtLandscape ? LP_T.fmtLandscape(lpTheme(scene.theme)) : lpTheme(scene.theme) + ' Landscape')
          : (LP_T.fmtTheme ? LP_T.fmtTheme(lpTheme(scene.theme)) : lpTheme(scene.theme) + ' Theme');
      elements.selectedCode.textContent = scene.code;
      elements.selectionSummaryText.textContent = getSelectedOptionsText() || lpt('unavailable','Unavailable');
      elements.totalPrice.textContent = formatMoney(getCurrentTotalPrice(), state.currency);
      elements.mobileSelectedName.textContent = lpName(scene.name);
      elements.mobilePrice.textContent = formatMoney(getCurrentTotalPrice(), state.currency);
      if (elements.startingPrice) {
        const displayPrice = (state.selectedVariant && state.selectedVariant.price) || activeProduct.priceMin || 0;
        elements.startingPrice.textContent = formatMoney(displayPrice, state.currency);
      }

      if (!activeProduct.hasProduct) {
        elements.selectedStatus.textContent = lpt('selectProduct','Select a product');
        elements.addToCartBtn.disabled = true;
        elements.addToCartBtn.textContent = isAcrylicCategory() ? lpt('selectAcrylicEditor','Select acrylic product in theme editor') : lpt('selectProductEditor','Select a product in theme editor');
      } else if (!state.selectedVariant) {
        elements.selectedStatus.textContent = lpt('unavailable','Unavailable');
        elements.addToCartBtn.disabled = true;
        elements.addToCartBtn.textContent = lpt('unavailable','Unavailable');
      } else if (!state.selectedVariant.available) {
        elements.selectedStatus.textContent = lpt('soldOut','Sold Out');
        elements.addToCartBtn.disabled = true;
        elements.addToCartBtn.textContent = lpt('soldOut','Sold Out');
      } else {
        elements.selectedStatus.textContent = lpt('inStock','In Stock');
        elements.addToCartBtn.disabled = false;
        elements.addToCartBtn.textContent = isAcrylicCategory() ? lpt('addAcrylic','Add acrylic panel') : lpt('addToCart','Add to cart');
      }
    }

    function renderMobileDrawer() {
      const scene = state.selectedScene;
      if (!scene) return;

      const optionFields = (state.productData.options || []).map((option) => {
        const mobileLabel = option.name.toLowerCase().includes('frame color') ? lpt('frameColor','Frame Color') : option.name;
        const optionsHtml = (option.values || []).map((value) => {
          const selected = state.optionValues[option.name] === value ? ' selected' : '';
          return '<option value="' + value.replace(/"/g, '&quot;') + '"' + selected + '>' + value + '</option>';
        }).join('');
        return [
          '<label class="lp-field lp-field--inline">',
          '  <span>' + mobileLabel + '</span>',
          '  <select data-role="mobile-option" data-option-name="' + option.name.replace(/"/g, '&quot;') + '">',
          optionsHtml,
          '  </select>',
          '</label>'
        ].join('');
      }).join('');

      elements.mobileDrawerContent.innerHTML = [
        '<div class="buy-panel buy-panel--mobile">',
        '  <div class="mobile-mini-preview">',
        '    <img loading="lazy" decoding="async" src="' + scene.image + '" alt="' + scene.name + '">',
        '    <div class="mobile-mini-copy">',
        '      <h3>' + scene.code + '</h3>',
        '    </div>',
        '  </div>',
        '  <div class="option-grid option-grid--mobile">',
        optionFields,
        '    <div class="lp-field lp-field--inline lp-field--qty">',
        '      <span>' + lpt('qty','Qty') + '</span>',
        '      <div class="qty-box qty-box--mobile">',
        '        <button type="button" data-role="mobile-qty-down" aria-label="Decrease quantity">-</button>',
        '        <input data-role="mobile-qty-input" type="number" min="1" value="' + state.quantity + '">',
        '        <button type="button" data-role="mobile-qty-up" aria-label="Increase quantity">+</button>',
        '      </div>',
        '    </div>',
        '  </div>',
        '  <div class="mobile-drawer-actionbar">',
        '    <div class="mobile-drawer-price">' + formatMoney(getCurrentTotalPrice(), state.currency) + '</div>',
        '    <button class="primary-btn mobile-drawer-add" type="button" data-role="mobile-add-to-cart"' + ((elements.addToCartBtn.disabled) ? ' disabled' : '') + '>' + elements.addToCartBtn.textContent + '</button>',
        '  </div>',
        '</div>'
      ].join('');

      elements.mobileDrawerContent.querySelectorAll('[data-role="mobile-option"]').forEach((select) => {
        select.addEventListener('change', () => {
          state.optionValues[select.dataset.optionName] = select.value;
          updateSelectedVariant();
          renderSelection();
          renderOptionGrid();
          renderMobileDrawer();
        });
      });

      const mobileQtyInput = elements.mobileDrawerContent.querySelector('[data-role="mobile-qty-input"]');
      const mobileQtyDown = elements.mobileDrawerContent.querySelector('[data-role="mobile-qty-down"]');
      const mobileQtyUp = elements.mobileDrawerContent.querySelector('[data-role="mobile-qty-up"]');
      const mobileAddToCart = elements.mobileDrawerContent.querySelector('[data-role="mobile-add-to-cart"]');

      if (mobileQtyInput) {
        mobileQtyInput.addEventListener('input', () => {
          state.quantity = Math.max(1, Number(mobileQtyInput.value || 1));
          mobileQtyInput.value = String(state.quantity);
          renderSelection();
          renderOptionGrid();
          renderMobileDrawer();
        });
      }
      if (mobileQtyDown) {
        mobileQtyDown.addEventListener('click', () => {
          state.quantity = Math.max(1, state.quantity - 1);
          renderSelection();
          renderOptionGrid();
          renderMobileDrawer();
        });
      }
      if (mobileQtyUp) {
        mobileQtyUp.addEventListener('click', () => {
          state.quantity += 1;
          renderSelection();
          renderOptionGrid();
          renderMobileDrawer();
        });
      }
      if (mobileAddToCart) {
        mobileAddToCart.addEventListener('click', addCurrentSelectionToCart);
      }
    }

    function setCartFx(totalEl, cents) {
      if (!totalEl || !totalEl.parentElement) return;
      const fx = totalEl.parentElement.querySelector('.lp-cart-fx');
      if (!fx) return;
      if (window.LPFx && window.LPFx.active && cents > 0) {
        fx.textContent = window.LPFx.formatCents(cents) + ' ' + window.LPFx.note;
        fx.style.display = 'block';
      } else {
        fx.style.display = 'none';
      }
    }

    function renderCartInto(listEl, totalEl) {
      const cart = state.cart;
      if (!state.cartLoaded && (!cart.items || !cart.items.length)) {
        listEl.innerHTML = '<li class="cart-empty">' + lpt('cartOpenToLoad','Open cart to load your latest items.') + '</li>';
        if (totalEl) { totalEl.textContent = formatMoney(0, state.currency); setCartFx(totalEl, 0); }
        return;
      }
      if (!cart.items || !cart.items.length) {
        listEl.innerHTML = '<li class="cart-empty">' + lpt('cartPickScene','Pick a scene from the gallery to start building your wall.') + '</li>';
        if (totalEl) { totalEl.textContent = formatMoney(0, state.currency); setCartFx(totalEl, 0); }
        return;
      }
      listEl.innerHTML = '';
      cart.items.forEach((item) => {
        const row = document.createElement('li');
        const imageUrl = (item.properties && item.properties['Image URL']) || (item.featured_image && item.featured_image.url) || item.image || '';
        const selectedScene = item.properties && (item.properties['Selected Scene'] || item.properties['Selected Panel Design'] || item.properties['Scene Code']);
        const theme = (item.properties && item.properties['_theme']) || '';
        row.className = 'cart-item';
        row.innerHTML = [
          '<img src="' + imageUrl + '" alt="' + item.product_title + '">',
          '<div>',
          '  <strong>' + (theme ? lpTheme(theme) : item.product_title) + '</strong>',
          (theme ? '  <p class="cart-item-subtitle">' + item.product_title + '</p>' : ''),
          '  <p>' + (selectedScene ? selectedScene + ' / ' : '') + item.variant_title + '</p>',
          '  <div class="cart-item-controls">',
          '    <div class="cart-qty-box">',
          '      <button type="button" data-action="decrease" data-key="' + item.key + '">-</button>',
          '      <span>' + item.quantity + '</span>',
          '      <button type="button" data-action="increase" data-key="' + item.key + '">+</button>',
          '    </div>',
          '    <button class="cart-remove-btn" type="button" data-action="remove" data-key="' + item.key + '">' + lpt('remove','Remove') + '</button>',
          '  </div>',
          '  <p>' + lpt('qtyLabel','Qty') + ' ' + item.quantity + ' / ' + formatMoney(item.line_price, state.currency) + '</p>',
          '</div>'
        ].join('');
        listEl.appendChild(row);
      });
      listEl.querySelectorAll('[data-action]').forEach((button) => {
        button.addEventListener('click', async () => {
          const key = button.getAttribute('data-key');
          const action = button.getAttribute('data-action');
          const item = state.cart.items.find((entry) => entry.key === key);
          if (!item) return;
          let quantity = item.quantity;
          if (action === 'increase') quantity += 1;
          if (action === 'decrease') quantity -= 1;
          if (action === 'remove') quantity = 0;
          await changeCartItem(key, quantity);
        });
      });
      if (totalEl) { totalEl.textContent = formatMoney(cart.total_price, state.currency); setCartFx(totalEl, cart.total_price); }
    }

    function updateBuyColumnMode() {
      if (!elements.buyColumnEl) return;
      elements.buyColumnEl.classList.toggle('acrylic-mode', isAcrylicCategory());
    }

    function renderCart() {
      elements.cartCount.textContent = String(state.cart.item_count || 0);
      if (elements.desktopCartCount) {
        elements.desktopCartCount.textContent = String(state.cart.item_count || 0);
      }
      renderCartInto(elements.cartList, elements.cartTotal);
      if (elements.desktopCartList) {
        renderCartInto(elements.desktopCartList, elements.desktopCartTotal);
      }
    }

    function renderAll() {
      renderCategories();
      renderThemes();
      renderScenes();
      renderOptionGrid();
      renderSelection();
      renderMobileDrawer();
      renderCart();
      updateBuyColumnMode();
    }

    async function loadCart() {
      if (cartPromise) {
        await cartPromise;
        return;
      }
      cartPromise = (async () => {
        try {
          const response = await fetch(LP_ROOT + 'cart.js', { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Unable to load cart');
          state.cart = await response.json();
        } catch (error) {
          console.error(error);
          state.cart = { item_count: 0, items: [], total_price: 0 };
        }
        state.cartLoaded = true;
        renderCart();
      })();
      try {
        await cartPromise;
      } finally {
        cartPromise = null;
      }
    }

    async function changeCartItem(key, quantity) {
      try {
        await fetch(LP_ROOT + 'cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
        await loadCart();
      } catch (error) {
        console.error('Unable to update cart item:', error);
      }
    }

    async function toggleCart(open) {
      const shouldOpen = typeof open === 'boolean' ? open : !elements.floatingCart.classList.contains('open');
      if (shouldOpen && !state.cartLoaded) {
        await loadCart();
      }
      elements.floatingCart.classList.toggle('open', shouldOpen);
      if (elements.cartBackdrop) elements.cartBackdrop.classList.toggle('open', shouldOpen);
      document.body.classList.toggle('lp-sheet-open', shouldOpen);
      elements.cartToggleBtn.setAttribute('aria-expanded', String(shouldOpen));
      if (shouldOpen) state.cartJustOpenedUntil = Date.now() + 350;
    }

    function toggleMobileDrawer(open) {
      const shouldOpen = typeof open === 'boolean' ? open : !elements.mobileDrawer.classList.contains('open');
      elements.mobileDrawer.classList.toggle('open', shouldOpen);
      document.body.classList.toggle('lp-sheet-open', shouldOpen);
      elements.mobileDrawer.setAttribute('aria-hidden', String(!shouldOpen));
    }

    async function addCurrentSelectionToCart() {
      const scene = state.selectedScene;
      if (!scene || !state.selectedVariant || !state.selectedVariant.available) return;
      const selectionLabel = isAcrylicCategory() ? 'Selected Panel Design' : 'Selected Scene';

      const payload = {
        items: [
          {
            id: state.selectedVariant.id,
            quantity: state.quantity,
            properties: {
              [selectionLabel]: scene.name,
              'Image URL': scene.image
            }
          }
        ]
      };

      try {
        await fetch(LP_ROOT + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        await loadCart();
        if (window.innerWidth < 1025) toggleCart(true);
        toggleMobileDrawer(false);
      } catch (error) {
        console.error('Unable to add item to cart:', error);
      }
    }

    function createQuickAddModal() {
      const modal = document.createElement('div');
      modal.className = 'lp-quick-add-overlay';
      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.innerHTML = [
        '<div class="lp-qa-backdrop"></div>',
        '<div class="lp-qa-sheet">',
        '  <div class="lp-qa-header">',
        '    <img class="lp-qa-image" src="" alt="">',
        '    <div class="lp-qa-meta">',
        '      <h3 class="lp-qa-code"></h3>',
        '      <p class="lp-qa-theme"></p>',
        '    </div>',
        '    <button class="lp-qa-close" type="button" aria-label="Close">&#x2715;</button>',
        '  </div>',
        '  <div class="lp-qa-body"></div>',
        '  <div class="lp-qa-footer">',
        '    <div class="lp-qa-reviews"><span class="lp-qa-stars">★★★★★</span><span class="lp-qa-rev-count">659+ ' + lpt('reviewsWord','reviews') + '</span></div>',
        '    <button class="primary-btn lp-qa-add-btn" type="button"><span class="lp-qa-add-label">' + lpt('addToCartMobile','Add to Cart') + '</span><span class="lp-qa-add-price"></span></button>',
        '    <button class="lp-qa-buy-btn" type="button">' + lpt('buyNow','Buy it now') + '</button>',
        '    <div class="lp-qa-fx-estimate" aria-hidden="true" style="display:none;"></div>',
        '    <div class="lp-qa-trust"><span>' + lpt('trustHandmade','Free worldwide shipping') + '</span><span>' + lpt('trustShips','Satisfaction guaranteed') + '</span><span>' + lpt('trustSecure','Secure checkout') + '</span></div>',
        '    <a class="lp-qa-details-link" href="#">' + lpt('viewDetails','View full details') + ' &rarr;</a>',
        '  </div>',
        '</div>'
      ].join('');
      document.body.appendChild(modal);
      modal.querySelector('.lp-qa-backdrop').addEventListener('click', closeQuickAdd);
      modal.querySelector('.lp-qa-close').addEventListener('click', closeQuickAdd);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeQuickAdd();
      });
      return modal;
    }

    function closeQuickAdd() {
      if (!quickAddModal) return;
      quickAddModal.setAttribute('aria-hidden', 'true');
      quickAddModal.classList.remove('open');
      document.body.classList.remove('lp-sheet-open');
      document.body.style.overflow = '';
    }

    // 从结账页返回(bfcache)会原样恢复整页 DOM，Quick Add 弹窗可能停在 Adding…/disabled。
    // 恢复时复位两个按钮并关闭弹窗，让用户回到可用的干净首页。
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted || !quickAddModal) return;
      const ab = quickAddModal.querySelector('.lp-qa-add-btn');
      const al = ab && ab.querySelector('.lp-qa-add-label');
      const bb = quickAddModal.querySelector('.lp-qa-buy-btn');
      if (ab) ab.disabled = false;
      if (al) al.textContent = lpt('addToCartMobile', 'Add to Cart');
      if (bb) { bb.disabled = false; bb.textContent = lpt('buyNow', 'Buy it now'); }
      closeQuickAdd();
    });

    function openQuickAdd(scene) {
      if (!quickAddModal) quickAddModal = createQuickAddModal();
      const modal = quickAddModal;
      const addBtn = modal.querySelector('.lp-qa-add-btn');
      const addLabel = addBtn.querySelector('.lp-qa-add-label');
      const addPrice = addBtn.querySelector('.lp-qa-add-price');
      const buyBtn = modal.querySelector('.lp-qa-buy-btn');
      const fxEst = modal.querySelector('.lp-qa-fx-estimate');
      const bodyEl = modal.querySelector('.lp-qa-body');

      modal.querySelector('.lp-qa-image').src = scene.image;
      modal.querySelector('.lp-qa-image').alt = scene.name;
      const qaIsCode = (state.category === 'Anime Light Painting' || isAcrylicCategory());
      modal.querySelector('.lp-qa-code').textContent = qaIsCode ? lpTheme(scene.theme) : scene.code;
      modal.querySelector('.lp-qa-theme').textContent = qaIsCode ? scene.code : (LP_T.fmtTheme ? LP_T.fmtTheme(lpTheme(scene.theme)) : lpTheme(scene.theme) + ' Theme');
      modal.querySelector('.lp-qa-details-link').href = '/products/' + scene.product_handle;
      bodyEl.innerHTML = '<p class="lp-qa-loading">' + lpt('loading','Loading…') + '</p>';
      bodyEl.onclick = null;
      addBtn.disabled = true;
      addLabel.textContent = lpt('addToCartMobile','Add to Cart');
      addPrice.textContent = '';
      addBtn.onclick = null;

      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('open');
      document.body.classList.add('lp-sheet-open');
      document.body.style.overflow = 'hidden';

      fetch(LP_ROOT + 'products/' + scene.product_handle + '.js', { credentials: 'same-origin' })
        .then((res) => {
          if (!res.ok) throw new Error('not found');
          return res.json();
        })
        .then((product) => {
          const productData = normalizeProductData({
            hasProduct: true,
            id: product.id,
            title: product.title,
            available: product.available,
            priceMin: product.price_min,
            options: product.options.map((o) => ({ name: o.name, values: o.values })),
            variants: product.variants.map((v) => ({ id: v.id, price: v.price, available: v.available, options: v.options }))
          });
          const optionValues = buildInitialOptionValues(productData);

          function getVariant() {
            return findVariantByOptions(productData, optionValues);
          }

          function renderPills() {
            bodyEl.querySelectorAll('.lp-qa-pills').forEach((pillGroup) => {
              const optionName = pillGroup.dataset.optionName;
              pillGroup.querySelectorAll('.lp-qa-pill').forEach((pill) => {
                const value = pill.dataset.value;
                const testVariant = findVariantByOptions(productData, Object.assign({}, optionValues, { [optionName]: value }));
                const unavailable = !testVariant || !testVariant.available;
                pill.classList.toggle('selected', optionValues[optionName] === value);
                pill.classList.toggle('unavailable', unavailable);
                pill.disabled = unavailable;
              });
            });
          }

          function updateAddBtn() {
            const variant = getVariant();
            if (!variant || !variant.available) {
              addBtn.disabled = true;
              buyBtn.disabled = true;
              addLabel.textContent = variant ? lpt('soldOut','Sold Out') : lpt('unavailable','Unavailable');
              addPrice.textContent = '';
              if (fxEst) fxEst.style.display = 'none';
            } else {
              addBtn.disabled = false;
              buyBtn.disabled = false;
              addLabel.textContent = lpt('addToCartMobile','Add to Cart');
              addPrice.textContent = formatMoney(variant.price, state.currency);
              if (fxEst) {
                if (window.LPFx && window.LPFx.active) {
                  fxEst.textContent = window.LPFx.formatCents(variant.price) + ' ' + window.LPFx.note;
                  fxEst.style.display = 'block';
                } else {
                  fxEst.style.display = 'none';
                }
              }
            }
            buyBtn.textContent = lpt('buyNow','Buy it now');
          }

          const optionGroupsHtml = productData.options.map((option) => {
            const pillsHtml = option.values.map((value) => {
              const testVariant = findVariantByOptions(productData, Object.assign({}, optionValues, { [option.name]: value }));
              const unavailable = !testVariant || !testVariant.available;
              return [
                '<button type="button" class="lp-qa-pill' + (optionValues[option.name] === value ? ' selected' : '') + (unavailable ? ' unavailable' : '') + '"',
                ' data-option-name="' + option.name.replace(/"/g, '&quot;') + '"',
                ' data-value="' + value.replace(/"/g, '&quot;') + '"',
                (unavailable ? ' disabled' : '') + '>',
                value,
                '</button>'
              ].join('');
            }).join('');
            return [
              '<div class="lp-qa-option-group">',
              '<div class="lp-qa-option-label">' + option.name + '</div>',
              '<div class="lp-qa-pills" data-option-name="' + option.name.replace(/"/g, '&quot;') + '">',
              pillsHtml,
              '</div>',
              '</div>'
            ].join('');
          }).join('');

          bodyEl.innerHTML = optionGroupsHtml;

          bodyEl.onclick = (event) => {
            const pill = event.target.closest('.lp-qa-pill');
            if (!pill || pill.disabled) return;
            optionValues[pill.dataset.optionName] = pill.dataset.value;
            renderPills();
            updateAddBtn();
          };

          addBtn.onclick = async () => {
            const variant = getVariant();
            if (!variant || !variant.available) return;
            addBtn.disabled = true;
            addLabel.textContent = lpt('adding','Adding…');
            addPrice.textContent = '';
            try {
              await fetch(LP_ROOT + 'cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({
                  items: [{ id: variant.id, quantity: 1, properties: { '_theme': scene.theme } }]
                })
              });
              addLabel.textContent = lpt('added','Added ✓');
              await loadCart();
              setTimeout(() => {
                closeQuickAdd();
                if (window.innerWidth < 1025) toggleCart(true);
              }, 800);
            } catch (error) {
              console.error('Quick add failed:', error);
              addBtn.disabled = false;
              updateAddBtn();
            }
          };

          buyBtn.onclick = async () => {
            const variant = getVariant();
            if (!variant || !variant.available) return;
            addBtn.disabled = true;
            buyBtn.disabled = true;
            buyBtn.textContent = lpt('adding','Adding…');
            try {
              await fetch(LP_ROOT + 'cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({
                  items: [{ id: variant.id, quantity: 1, properties: { '_theme': scene.theme } }]
                })
              });
              window.location.href = LP_ROOT + 'checkout';
            } catch (error) {
              console.error('Buy now failed:', error);
              buyBtn.textContent = lpt('buyNow','Buy it now');
              updateAddBtn();
            }
          };

          updateAddBtn();
        })
        .catch(() => {
          bodyEl.innerHTML = '<p class="lp-qa-error">This product is currently unavailable.</p>';
        });
    }

    elements.themeSearchInput.addEventListener('input', (event) => {
      state.query = event.target.value;
      renderScenes();
    });

    elements.clearSearchBtn.addEventListener('click', async () => {
      state.query = '';
      elements.themeSearchInput.value = '';
      await changeCategory(defaultCategory);
    });

    elements.addToCartBtn.addEventListener('click', addCurrentSelectionToCart);
    elements.mobileDrawerToggle.addEventListener('click', () => toggleMobileDrawer(true));
    elements.mobileDrawerClose.addEventListener('click', () => toggleMobileDrawer(false));
    if (elements.mobileThemePrev) {
      elements.mobileThemePrev.addEventListener('click', () => stepMobileTheme(-1));
    }
    if (elements.mobileThemeNext) {
      elements.mobileThemeNext.addEventListener('click', () => stepMobileTheme(1));
    }
    if (elements.mobileThemeCurrent) {
      elements.mobileThemeCurrent.addEventListener('click', () => {
        if ((state.category !== 'Anime Light Painting' && !isAcrylicCategory()) || !isMobileViewport()) return;
        if (elements.themeModal && elements.themeModal.classList.contains('open')) {
          toggleThemeModal(false);
          return;
        }
        renderThemeModalList();
        toggleThemeModal(true);
      });
    }
    if (elements.themeModalClose) {
      elements.themeModalClose.addEventListener('click', () => toggleThemeModal(false));
    }
    if (elements.themeModalBackdrop) {
      elements.themeModalBackdrop.addEventListener('click', () => toggleThemeModal(false));
    }
    if (elements.imagePreviewClose) {
      elements.imagePreviewClose.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleImagePreview(false);
      });
      elements.imagePreviewClose.addEventListener('touchend', (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleImagePreview(false);
      }, { passive: false });
    }
    if (elements.imagePreviewBackdrop) {
      elements.imagePreviewBackdrop.addEventListener('click', () => toggleImagePreview(false));
      elements.imagePreviewBackdrop.addEventListener('touchend', (event) => {
        event.preventDefault();
        toggleImagePreview(false);
      }, { passive: false });
    }
    if (elements.imagePreviewSheet) {
      elements.imagePreviewSheet.addEventListener('click', (event) => {
        const target = event.target;
        if (target instanceof HTMLElement && target.closest('[data-role="image-preview-img"]')) return;
        toggleImagePreview(false);
      });
      elements.imagePreviewSheet.addEventListener('touchend', (event) => {
        const target = event.target;
        if (target instanceof HTMLElement && target.closest('[data-role="image-preview-img"]')) return;
        event.preventDefault();
        toggleImagePreview(false);
      }, { passive: false });
    }
    if (elements.imagePreviewImg) {
      elements.imagePreviewImg.addEventListener('click', (event) => {
        event.stopPropagation();
      });
      elements.imagePreviewImg.addEventListener('touchend', (event) => {
        event.stopPropagation();
      });
    }
    elements.mobileDrawer.addEventListener('click', (event) => {
      if (event.target instanceof HTMLElement && event.target.dataset.closeDrawer === 'true') {
        toggleMobileDrawer(false);
      }
    });
    elements.cartToggleBtn.addEventListener('click', () => {
      toggleCart().catch((error) => console.error('Unable to toggle cart:', error));
    });
    elements.cartCloseBtn.addEventListener('click', () => {
      toggleCart(false).catch((error) => console.error('Unable to close cart:', error));
    });
    if (elements.cartBackdrop) {
      elements.cartBackdrop.addEventListener('click', () => {
        toggleCart(false).catch((error) => console.error('Unable to close cart:', error));
      });
    }

    document.addEventListener('click', (event) => {
      if (!elements.floatingCart.classList.contains('open')) return;
      if (Date.now() < state.cartJustOpenedUntil) return;
      const target = event.target;
      if (!(target instanceof Node)) return;
      if (!elements.floatingCart.contains(target)) {
        toggleCart(false).catch((error) => console.error('Unable to close cart:', error));
      }
    });

    window.addEventListener('resize', () => {
      normalizeAnimeThemeForViewport();
      if (!isMobileViewport()) toggleThemeModal(false);
      renderThemes();
      renderScenes();
    });

    const params = new URLSearchParams(window.location.search);
    const categoryParam = slugifyCategory(params.get('category'));
    const matchedCategory = categories.find((category) => slugifyCategory(category) === categoryParam) || defaultCategory;
    if (matchedCategory) {
      state.category = matchedCategory;
      state.theme = 'All';
      await ensureCategoryScenesLoaded(matchedCategory);
      if (defaultTheme && defaultTheme !== 'All' && getThemes().indexOf(defaultTheme) >= 0) {
        state.theme = defaultTheme;
      }
      state.selectedScene = findFirstSceneByCategory(matchedCategory) || state.selectedScene;
    }

    setActiveProductForCategory(state.category, true);
    normalizeAnimeThemeForViewport();
    if (!state.selectedScene) {
      state.selectedScene = findFirstSceneByCategory('Landscape Series') || findFirstSceneByCategory('Anime Light Painting');
    }

    renderAll();

    const heroCta = root.querySelector('.hero-cta');
    if (heroCta) {
      heroCta.addEventListener('click', async (event) => {
        event.preventDefault();
        state.category = 'Anime Light Painting';
        state.query = '';
        state.theme = 'All';
        await ensureCategoryScenesLoaded('Anime Light Painting');
        if (defaultTheme && defaultTheme !== 'All' && getThemes().indexOf(defaultTheme) >= 0) {
          state.theme = defaultTheme;
        }
        normalizeAnimeThemeForViewport();
        state.selectedScene = findFirstSceneByCategory('Anime Light Painting') || state.selectedScene;
        setActiveProductForCategory('Anime Light Painting', true);
        state.quantity = 1;
        renderAll();
        const shop = document.getElementById('lp-shop');
        if (shop) shop.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    loadCart().catch((err) => console.error('Cart preload failed:', err));
  }

  function initAllSections() {
    document.querySelectorAll('.lightpainting-home[data-lightpainting-home]').forEach((section) => {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }
})();

/* Hero Light Off ⇄ On compare slider */
(function () {
  function initLpCompare() {
    var frame = document.querySelector('[data-lp-frame]');
    if (!frame) return;
    function setPct(p) {
      p = Math.max(2, Math.min(98, p));
      frame.style.setProperty('--lp-pct', p + '%');
    }
    function pctFromEvent(e) {
      var rect = frame.getBoundingClientRect();
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPct(((clientX - rect.left) / rect.width) * 100);
    }
    var dragging = false;
    frame.addEventListener('mousedown', function (e) { dragging = true; pctFromEvent(e); e.preventDefault(); });
    window.addEventListener('mousemove', function (e) { if (dragging) pctFromEvent(e); });
    window.addEventListener('mouseup', function () { dragging = false; });
    frame.addEventListener('touchstart', function (e) { dragging = true; pctFromEvent(e); }, { passive: true });
    frame.addEventListener('touchmove', function (e) { if (dragging) pctFromEvent(e); }, { passive: true });
    frame.addEventListener('touchend', function () { dragging = false; });
    var knob = frame.querySelector('[data-lp-knob]');
    if (knob) {
      knob.addEventListener('keydown', function (e) {
        var cur = parseFloat(getComputedStyle(frame).getPropertyValue('--lp-pct')) || 48;
        if (e.key === 'ArrowLeft') { setPct(cur - 4); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setPct(cur + 4); e.preventDefault(); }
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLpCompare);
  } else {
    initLpCompare();
  }
})();













